import axios, {AxiosResponse} from 'axios'
import {OnboardingProgress, WorkingDayForm} from './_models'

const API_URL = process.env.REACT_APP_THEME_API_URL
const ONBOARDING_URL = `${API_URL}/api/onboarding`
const USER_URL = `${API_URL}/api/usuarios`

type ProgressResponse = {data: OnboardingProgress}

const getOnboardingProgress = (): Promise<OnboardingProgress> =>
  axios
    .get(`${ONBOARDING_URL}/progress`)
    .then((response: AxiosResponse<ProgressResponse>) => response.data.data)

const markOnboardingItem = (key: string): Promise<OnboardingProgress> =>
  axios
    .post(`${ONBOARDING_URL}/progress/${key}`)
    .then((response: AxiosResponse<ProgressResponse>) => response.data.data)

const setOnboardingDismissed = (dismissed: boolean): Promise<OnboardingProgress> =>
  axios
    .post(`${ONBOARDING_URL}/${dismissed ? 'dismiss' : 'reopen'}`)
    .then((response: AxiosResponse<ProgressResponse>) => response.data.data)

// Marca o primeiro acesso como visto (libera o app para o usuário).
const finishOnboarding = (): Promise<void> =>
  axios.put(`${USER_URL}/update-onboarding`, {onboarded: true}).then(() => undefined)

const updateWorkingDay = (values: WorkingDayForm): Promise<void> =>
  axios.put(`${USER_URL}/update-working-day`, values).then(() => undefined)

export {
  getOnboardingProgress,
  markOnboardingItem,
  setOnboardingDismissed,
  finishOnboarding,
  updateWorkingDay,
}
